import React from "react";
import cn from "classnames";
import styles from "./TypeTextarea.module.scss";
import { HomePageError } from "@/components/common/HomePageError";
interface TypeTextareaProps {
  label?: string;
  placeholder: string;
  name: string;
  value?: string;
  defaultValue?: string;
  errors?: string[] | null;
  maxLength?: number;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onInput?: (e: any) => void;
  isRequired?: boolean;
  textareaRef?: React.Ref<HTMLTextAreaElement>;
  autoFocus?: boolean;
  style?: React.CSSProperties;
  counterStyle?: React.CSSProperties;
  customError?: boolean;
  showCounter?: boolean;
  showCounterDesktop?: boolean;
  resize?: boolean;
  cls?: string;
  parentCls?: string;
}
const TypeTextarea: React.FC<TypeTextareaProps> = ({
  label,
  placeholder,
  name,
  value,
  defaultValue,
  errors,
  maxLength,
  onChange,
  onInput,
  isRequired = false,
  textareaRef,
  autoFocus,
  style,
  counterStyle,
  customError,
  showCounter = true,
  showCounterDesktop,
  resize,
  parentCls,
  cls
}) => {
  const currentLength = value?.length || defaultValue?.length || 0;
  return <>
            <div className={cn(styles.TextAreaBox, parentCls)}>
                {label && <label className={styles.Title}>
                        {label}
                        {isRequired && <span>*</span>}
                    </label>}
                <textarea autoComplete="off" data-hj-allow ref={textareaRef} className={cn(styles.TextArea, cls, {
        [styles.resize]: resize,
        [styles.error]: errors
      })} name={name} placeholder={placeholder} onChange={onChange} onInput={onInput} autoFocus={autoFocus} style={style} maxLength={maxLength} {...value !== undefined ? {
        value
      } : {
        defaultValue
      }} />
                {showCounter && maxLength ? <div className={cn(styles.Counter, {
        [styles.showOnDesktop]: showCounterDesktop,
        [styles.error]: errors
      })} style={counterStyle}>
                        {currentLength}/{maxLength}
                    </div> : null}
            </div>
            {!customError && errors && <HomePageError errors={errors} />}
        </>;
};
export default TypeTextarea;